import { useMemo } from "react";
import { computeRetirementBuckets } from "@/utils/financialPageFunctions";
import { RetirementBucketAllocation, RetirementBucketAmounts } from "@/type/financialPageTypes";

// Shared by the Pre-Retirement summary and the Post-Retirement scenario/summary screens
// to split a corpus into pension/health/vacation/legacy buckets.
export function useRetirementBuckets(
  corpus: number,
  tenure: number,
  allocation: RetirementBucketAllocation,
  legacyGrowthRate?: number,
): RetirementBucketAmounts {
  return useMemo(
    () => computeRetirementBuckets(corpus, tenure, allocation, legacyGrowthRate),
    [corpus, tenure, allocation.pension, allocation.healthEmergency, allocation.vacation, allocation.legacy, legacyGrowthRate],
  );
}
